export const SET_IS_REGISTERED_ORG = 'SET_IS_REGISTERED_ORG';
export const SET_LOADING_ORG = 'SET_LOADING_ORG';
export const SET_ORGANISATION_DATA = 'SET_ORGANISATION_DATA';
